<h2>Edit</h2>
<!--<p><i>*Changes are live</i></p>-->

@if (!editHtml) {
  <div class="row">
    <div class="col-md-12">
      @for (insertable of widget.insertables; track insertable) {
        <mat-form-field class="field">
          <!--<input mdInput type="text" placeholder="Data Input" [(ngModel)]="insertable.value">-->
          <textarea matInput placeholder="{{insertable.label}}" [(ngModel)]="insertable.value"></textarea>
        </mat-form-field>
      }
    </div>
  </div>
}

@if (editHtml) {
  <div class="row">
    <div class="col-md-12">
      <mat-form-field class="field">
        <textarea cols="120" rows="20" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" matInput placeholder="Html Template" [(ngModel)]="widget.htmlTemplate"></textarea>
      </mat-form-field>
    </div>
  </div>
}

<div class="row">
  <div class="col-md-12">
    <button mat-raised-button class="btn btn-primary pull-right" (click)="close()">Close</button>
    <button mat-raised-button class="btn btn-info pull-right" (click)="editHtmlTemplate()">
      @if (editHtml) {
        <span>Edit Variables</span>
        }@if (!editHtml) {
        <span>Edit HTML Template</span>
      }
    </button>
    <button mat-raised-button class="btn btn-danger pull-right" (click)="delete()">Delete</button>
  </div>
</div>
